import {Component} from 'react';
import {Link, Navigate} from "react-router-dom";
import config from "../config.json";
import CreatableSelect from "react-select/creatable";
import {ActionMeta, OnChangeValue} from 'react-select';
import Geocoder from 'react-geonames';
import 'react-geonames/dist/geonames.css';
let duplicateUri = false;
const queryParams = {
    type: 'json',
    maxRows: 5,
};

class NewWineEntry extends Component {

    constructor(props) {
        super(props);
        this.state = {
            success: false,
            family: {},
            families: [],
            geoName: null,
            goToLogin: false
        };
        this.addWine = this.addWine.bind(this)
        this.onSelect = this.onSelect.bind(this)
        this.onClear = this.onClear.bind(this)
    }

    componentDidMount() {
        this.getFamilies();
    }

    onSelect = (place, placename) => {
        this.setState({
            geoName: {
                uri: "http://sws.geonames.org/" + place.geonameId,
                geonameId: place.geonameId,
                name: place.name,
                adminName1: place.adminName1,
                countryName: place.countryName,
                countryCode: place.countryCode,
            }
        });
    };

    onClear = () => {
        this.setState({geoName: null});
    };

    addWine = (event) => {
        event.preventDefault();
        fetch(config.serverUrl_local + `/wine/add-wine`,
            {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    title: this.state.name,
                    family: this.state.family,
                    imageUrl: this.state.url,
                    geoName: this.state.geoName
                })
            }).then(async response => {
            const data = await response;
            // check for error response
            if (!response.ok) {
                // get error message from body or default to response statusText
                if (response.status === 404) duplicateUri = true;

                if (response.status === 400)
                    this.setState({goToLogin: true})
                const error = (data && data.message) || response.statusText;
                return Promise.reject(error);
            }
            this.setState({success: true});
        })
            .catch(error => {
                this.setState({errorMessage: error.toString()});
                console.error('There was an error!', error);
            });
    }

    getFamilies = () => {
        fetch(config.serverUrl_local + `/wine/families`, {credentials: 'include'})
            .then((response) => response.json())
            .then((json) => {
                const families = json.map(family => {
                    return {
                        label: family.name,
                        value: family.uri
                    }
                })
                this.setState({families})
                console.log(families);
            });
    }

    createFamily = (name) => {
        const formdata = new FormData();
        formdata.append("name", name);

        const requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow',
            credentials: 'include'
        };

        fetch(config.serverUrl_local + `/wine/add-family`, requestOptions
        ).then(async response => {
            const data = await response.json();
            // check for error response
            if (!response.ok) {
                // get error message from body or default to response statusText
                if (response.status === 400)
                    this.setState({goToLogin: true})
                const error = (data && data.message) || response.statusText;
                return Promise.reject(error);
            }
            this.setState({
                family: data
            })
        })
            .catch(error => {
                this.setState({errorMessage: error.toString()});
                console.error('There was an error!', error);
            });
    }

    handleChange = (
        newValue: OnChangeValue<any, false>,
        actionMeta: ActionMeta<any>
    ) => {
        if (actionMeta.action === 'create-option') {
            this.createFamily(newValue.label);
        } else {
            this.setState({
                family: {
                    name: newValue.label,
                    uri: newValue.value
                }
            })
        }
    };

    render() {
        return <>
            {this.state.success && (
                <Navigate to="/wine-list" replace={true}/>
            )}
            {this.state.goToLogin && (
                <Navigate to="/" replace={true}/>
            )}
            <div className="container">
                <div className="d-flex flex-column align-items-center justify-content-center  vh-100">
                    <fieldset className="fieldset-custom border p-3">
                        <div className="header-logo align-bottom">
                            <legend className="w-auto">Le vin est un voyage</legend>
                        </div>
                        {/*<legend className="w-auto">Créez nouveau vin</legend>*/}
                        <form onSubmit={this.addWine} className="form-white form-login form-width ">
                            <div className="form-group">
                                <label className="display-start m-2">Nom du vin</label>
                                <input type="text" className="form-control form-control-lg p-2" id="name"
                                       required
                                       maxLength={30}
                                       onChange={event => this.setState({name: event.target.value})}
                                       placeholder="Nom du vin"/>
                            </div>
                            <div className="form-group">
                                <label className="display-start m-2">Page web du vin</label>
                                <input type="text" className="form-control form-control-lg p-2" id="url"
                                       required
                                       onChange={event => this.setState({url: event.target.value})}
                                       placeholder="Url de la page internet"/>
                                {duplicateUri===true ?<div className="display-error m-2">L'objet avec cette url existe déjà</div> : "" }
                            </div>
                            <div className="form-group">
                                <label className="display-start m-2">Nom du domaine</label>
                                <CreatableSelect id="families"
                                                 className={"select_container"}
                                                 classNamePrefix={"select"}
                                                 onChange={this.handleChange}
                                                 options={this.state.families}/>
                            </div>
                            {/*<div className="form-group">*/}
                            {/*    <label className="display-start m-2">Pays</label>*/}
                            {/*    <input type="text" className="form-control form-control-lg p-2" id="country"*/}
                            {/*           required*/}
                            {/*           onChange={event => this.setState({country: event.target.value})}*/}
                            {/*           placeholder="Pays"/>*/}
                            {/*</div>*/}
                            {/*<div className="form-group">*/}
                            {/*    <label className="display-start m-2">Ville</label>*/}
                            {/*    <input type="text" className="form-control form-control-lg p-2" id="city"*/}
                            {/*           required*/}
                            {/*           onChange={event => this.setState({city: event.target.value})}*/}
                            {/*           placeholder="Ville"/>*/}
                            {/*</div>*/}

                            <Geocoder
                                username="sklasnja"
                                https
                                queryParams={queryParams}
                                label="Ville"
                                placeholder="Ville"
                                onSelect={this.onSelect}
                                onClear={this.onClear}
                            />

                            <div className="m-1">
                                <button type="submit" className="btn btn-primary m-4">Ajouter le vin</button>
                                <Link to="/wine-list" className="btn btn-secondary m-4">Annuler</Link>
                            </div>
                            <div className="m-1">
                                <a href="mailto:contact@laleph.com">Besoin d’aide?</a>

                            </div>
                        </form>
                    </fieldset>
                </div>
            </div>
        </>
    }
}

export default NewWineEntry